import { c as _c } from "react/compiler-runtime";
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Dialog, Form } from '@onefootprint/ui';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import useDuplicatePlaybook from './use-duplicate-playbook';
type DuplicateDialogProps = {
  playbook: {
    id: string;
    name: string;
  };
  publishedVersion: PlaybookVersionNoGraph;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
type DuplicateFormData = {
  name: string;
};
const DuplicateDialog = t0 => {
  const $ = _c(65);
  const {
    playbook,
    publishedVersion,
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header.leftHeaderActions.duplicatePlaybook.dialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const duplicatePlaybookMutation = useDuplicatePlaybook();
  let t2;
  if ($[1] !== playbook.name || $[2] !== t) {
    t2 = t(_temp, {
      name: playbook.name
    });
    $[1] = playbook.name;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      defaultValues: {
        name: t2
      }
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const form = useForm(t3);
  let t4;
  if ($[6] !== form || $[7] !== playbook.name || $[8] !== t) {
    t4 = () => {
      form.reset({
        name: t(_temp2, {
          name: playbook.name
        })
      });
    };
    $[6] = form;
    $[7] = playbook.name;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== open || $[11] !== playbook.name) {
    t5 = [open, playbook.name];
    $[10] = open;
    $[11] = playbook.name;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== onOpenChange) {
    t6 = () => {
      onOpenChange(false);
    };
    $[13] = onOpenChange;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const close = t6;
  let t7;
  if ($[15] !== close || $[16] !== duplicatePlaybookMutation || $[17] !== publishedVersion) {
    t7 = async formData => {
      ;
      try {
        await duplicatePlaybookMutation.mutateAsync({
          body: {
            name: formData.name
          },
          path: {
            id: publishedVersion.id
          }
        });
        close();
      } catch (t8) {
        const _ = t8;
      }
    };
    $[15] = close;
    $[16] = duplicatePlaybookMutation;
    $[17] = publishedVersion;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleSubmit = t7;
  let t8;
  if ($[19] !== t) {
    t8 = t(_temp3);
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== form.formState.isSubmitting || $[22] !== t8) {
    t9 = {
      form: "duplicate-playbook-form",
      label: t8,
      loading: form.formState.isSubmitting,
      type: "submit"
    };
    $[21] = form.formState.isSubmitting;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = form.formState.isSubmitting;
  let t11;
  if ($[24] !== t) {
    t11 = t(_temp4);
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== close || $[27] !== form.formState.isSubmitting || $[28] !== t11) {
    t12 = {
      disabled: t10,
      label: t11,
      onClick: close
    };
    $[26] = close;
    $[27] = form.formState.isSubmitting;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t(_temp5);
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== form || $[33] !== handleSubmit) {
    t14 = form.handleSubmit(handleSubmit);
    $[32] = form;
    $[33] = handleSubmit;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t) {
    t15 = t(_temp6);
    $[35] = t;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15) {
    t16 = <p className="text-body-2 text-primary">{t15}</p>;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t) {
    t17 = t(_temp7);
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t) {
    t18 = t(_temp8);
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t(_temp9);
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t19) {
    t20 = {
      required: t19
    };
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t17 || $[48] !== t18 || $[49] !== t20) {
    t21 = <Form.Input size="compact" label={t17} name="name" placeholder={t18} rules={t20} />;
    $[47] = t17;
    $[48] = t18;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t14 || $[52] !== t16 || $[53] !== t21) {
    t22 = <form id="duplicate-playbook-form" onSubmit={t14} className="flex flex-col gap-6">{t16}{t21}</form>;
    $[51] = t14;
    $[52] = t16;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== form || $[56] !== t22) {
    t23 = <FormProvider {...form}>{t22}</FormProvider>;
    $[55] = form;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== close || $[59] !== open || $[60] !== t12 || $[61] !== t13 || $[62] !== t23 || $[63] !== t9) {
    t24 = <Dialog onClose={close} open={open} isConfirmation={true} primaryButton={t9} secondaryButton={t12} size="compact" title={t13}>{t23}</Dialog>;
    $[58] = close;
    $[59] = open;
    $[60] = t12;
    $[61] = t13;
    $[62] = t23;
    $[63] = t9;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  return t24;
};
export default DuplicateDialog;
function _temp($) {
  return $.name.default;
}
function _temp2($_0) {
  return $_0.name.default;
}
function _temp3($_1) {
  return $_1.cta;
}
function _temp4($_2) {
  return $_2.cancel;
}
function _temp5($_3) {
  return $_3.title;
}
function _temp6($_4) {
  return $_4.description;
}
function _temp7($_5) {
  return $_5.name.label;
}
function _temp8($_6) {
  return $_6.name.placeholder;
}
function _temp9($_7) {
  return $_7.name.errors.required;
}